import { render, staticRenderFns } from "./CCalendarCategoryPanel.vue?vue&type=template&id=7faa6e60&scoped=true"
import script from "./CCalendarCategoryPanel.vue?vue&type=script&lang=ts"
export * from "./CCalendarCategoryPanel.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarCategoryPanel.vue?vue&type=style&index=0&id=7faa6e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa6e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
